<template>
    <div class="flex justify-center gap-2">
        <button v-for="index in slidesCount" :key="index" @click="$emit('go-to-slide', index - 1)" :class="{
            'w-8 h-2 rounded-full bg-[#2459A8]': currentSlide === index - 1,
            'w-2 h-2 rounded-full bg-white border !border-[#2459A8]': currentSlide !== index - 1
        }" class="transition-all duration-300" ></button>
    </div>
</template>

<script>
export default {
    props: {
        currentSlide: Number,
        slidesCount: Number,
    },
};
</script>
